import ServiceCard from './ServiceCard';
import type { ServicesProps } from './useServices';

const ServicesDesktop = ({ data, handleServiceClick }: ServicesProps) => {
  return (
    <section
      id="services"
      className="flex flex-col items-center gap-15 bg-surface-primary px-20 py-25"
    >
      <div className="flex max-w-[600px] flex-col items-center gap-4 text-center">
        <span className="font-body text-sm font-semibold tracking-widest text-accent-text">
          {data.label}
        </span>
        <h2 className="font-heading text-5xl font-medium text-foreground-primary">
          {data.title}
        </h2>
      </div>

      <div className="grid w-full grid-cols-4 gap-8">
        {data.services.map((service) => (
          <ServiceCard
            key={service.id}
            service={service}
            onClick={handleServiceClick}
          />
        ))}
      </div>
    </section>
  );
};

export default ServicesDesktop;
